import { LogOut, Menu } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { GlobalSearch } from './GlobalSearch';
import { copy, formatRole } from '../lib/copy';
import type { AdminProductVariant } from '../lib/admin-product';
import { ADMIN_PRODUCT } from '../lib/admin-product';

export function TopBar({
  product = ADMIN_PRODUCT,
  onMenuClick,
}: {
  product?: AdminProductVariant;
  onMenuClick?: () => void;
}) {
  const { operator, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login', { replace: true });
  };

  return (
    <header className="flex h-14 items-center justify-between gap-3 border-b border-ops-border bg-ops-surface px-4 md:px-6">
      <div className="flex items-center gap-3">
        <button
          type="button"
          className="ops-btn-secondary p-2 lg:hidden"
          onClick={onMenuClick}
          aria-label="Меню"
        >
          <Menu className="h-5 w-5" />
        </button>
        <p className="hidden text-sm text-ops-muted sm:block">{copy.topBar.session}</p>
      </div>
      <div className="flex items-center gap-3">
        <GlobalSearch product={product} />
        {operator ? (
          <div className="hidden text-right text-sm sm:block">
            <p className="font-medium text-ops-text">{operator.email}</p>
            <p className="text-xs text-ops-muted">{formatRole(operator.role)}</p>
          </div>
        ) : null}
        <button type="button" onClick={handleLogout} className="ops-btn-secondary py-2">
          <LogOut className="h-4 w-4" />
          <span className="hidden sm:inline">{copy.common.logout}</span>
        </button>
      </div>
    </header>
  );
}
